import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import GroupQuestionsEditForm from "./GroupQuestionsEditForm";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";
import { Draggable } from 'react-beautiful-dnd';

function GroupQuestionsListItem({ id, index, type, text, moduleId, onAddToModule, isSortable = true }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [name, setName] = useState(text);
    const availableLan = useGetAvailableLanguages();

    const handleToModule = () => {
        onAddToModule?.(id);
    };

    const handleUpdate = (newName) => {
        if (newName.text) setName(newName.text);
        setIsOpen(false);
    };

    const content = (
        <div className="questionWrap">
            {!isOpen ? (
                <>
                    {isSortable && <span className="move"></span>}
                    <input
                        id={id}
                        type="checkbox"
                        checked={isSortable}
                        onChange={handleToModule}
                        title=""
                    />
                    <label htmlFor={id} title=""></label>
                    <div
                        className="questionWrapDiv"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {availableLan.map((lng) => (
                            <span key={lng}>
                                <strong>{lng}: </strong>
                                {name && name.hasOwnProperty(lng) ? (
                                    <>
                                        {name[lng]}
                                        {!name[lng] && <span className="noTranslation" />}
                                    </>
                                ) : (
                                    <span className="noTranslation" />
                                )}
                            </span>
                        ))}
                        <button
                            type="button"
                            className="btn btn-default btn-edit btn-editInput"
                        >
                            {t("admin.common.edit")}
                        </button>
                    </div>
                </>
            ) : (
                <GroupQuestionsEditForm
                    id={id}
                    type={type}
                    moduleId={moduleId}
                    onClose={() => setIsOpen(false)}
                    onConfirm={handleUpdate}
                    onAdd={handleToModule}
                />
            )}
        </div>
    );

    // Conditionally render `Draggable` only when `isSortable` is true
    if (isSortable) {
        return (
            <Draggable draggableId={id.toString()} index={index}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                            ...provided.draggableProps.style,
                            opacity: snapshot.isDragging ? 0.5 : 1,
                        }}
                    >
                        {content}
                    </div>
                )}
            </Draggable>
        );
    } else {
        // Render without Draggable when not sortable
        return <div>{content}</div>;
    }
}

export default GroupQuestionsListItem;
